import React, { Component, useState, useEffect } from 'react'
import {
    PrimaryButton,
    Dialog,
    DialogFooter,
    DefaultButton,
    DialogType,
    MessageBar,
    MessageBarType,
    Label
} from 'office-ui-fabric-react'

import './CustomDialog.css'

// Dialog form state props
interface IErrorDialogProps {
    title: string;
    subText?: string,
    errorMessage: string,
    errorContent?: React.ReactNode,
    apiUrl?: string,
    detailErrorMessage?: string
    showErrorDialog: boolean;
    messageBarType?: MessageBarType;
    errorCategory?: "UserError" | "SystemError" | "UnknownError",
    onErrorDialogDismiss: () => void;
}

/**
 * Auto healing review dialog
 */
export default function ErrorDialog(props: IErrorDialogProps) {
    
    return (
        <>
            {
                props.showErrorDialog &&
                <Dialog
                    hidden={false}
                    title={props.title}
                    modalProps={{
                        containerClassName: 'autohealing-error-dialog-container',
                        isBlocking: false
                    }}
                    onDismiss={() => this.props.hideHandoffDialog()}
                >
                    <div className="autohealing-dialog-content">
                        <MessageBar messageBarType={props.messageBarType}>
                            {props.errorContent? props.errorContent: props.errorMessage}
                        </MessageBar>
                        {props.detailErrorMessage && <Label>Error detail: {props.detailErrorMessage}</Label>}
                        {
                            props.errorCategory === "SystemError" &&
                            <span style={{ fontSize: "12px", color: "dimgray" }}>Support ticket Id: $NOT_AVAILABLE {"GET: [ "}{props.apiUrl}{"]"}</span>
                        }
                        
                        <div style={{ marginTop: "5px" }}>Timestamp: {new Date().toLocaleString()}</div>
                    </div>
                    <DialogFooter>
                        <PrimaryButton onClick={() => props.onErrorDialogDismiss()}>Dismiss</PrimaryButton>
                    </DialogFooter>
                </Dialog>
            }
        </>
    )
}